<template>
    <div class="flex flex-col gap-2">
        <USwitch v-model="model" :label="`Fullfør oppgave #${assignmentNo}`" />
    </div>
</template>

<script setup lang="ts">
const model = defineModel<boolean>({ required: true })

defineProps({
    assignmentNo: {
        type: Number,
        required: true
    },
})
</script>

<style scoped>

</style>